/**
 * src/hooks/useSesionCeroF1.js
 * React Query v5 de la puerta del F1.
 *
 * ⚠️ `useMutation` PARA UN GET, a propósito y no por descuido. Lo que importa aquí
 * no es el verbo HTTP: es que la medida se toma CUANDO ALGUIEN LA PIDE y no al
 * entrar en la pantalla. Un `useQuery` normal la dispararía con cada visita a
 * «Uso», y esta recorre todos los tenants vivos leyendo sus OCs. Un `useQuery` con
 * `enabled: false` + `refetch` haría lo mismo que esto con más piezas y dejando una
 * caché que haría pasar por «medido ahora» algo medido hace una hora.
 *
 * Y no se cachea a propósito: volver a pulsar tiene que volver a medir. El propio
 * servicio lo dice —«volver a abrirla mañana da la medida de mañana»—, y la
 * respuesta trae su `medido_en` para que la pantalla pueda decir de cuándo es.
 */
import { useMutation } from '@tanstack/react-query'

import { getSesionCeroDelImpacto } from '../api/impactoF1'

export function useSesionCeroF1() {
  return useMutation({ mutationFn: getSesionCeroDelImpacto })
}
